// 品牌設定（LOGO、名稱、favicon）
//
// 刻意在「執行時」向 /brand/brand.json 取得，而不是編譯時寫死：
// 換 LOGO 只要替換 nginx/brand/ 底下的檔案再重新整理，
// 不用重新 build、不用重新部署，也不用每個院區各編一版。
//
// 取不到時退回下面的預設值，畫面不會因此壞掉。

import { useEffect, useState } from "react";

export const DEFAULT_BRAND = {
  appName: "手術指導",
  logo: null,              // null = 顯示文字而非圖片
  favicon: null,
  showJitsiWatermark: true, // 會議畫面裡要不要顯示我們的 LOGO
};

const BRAND_URL = "/brand/brand.json";

let cached = null;

export const loadBrand = async () => {
  if (cached) return cached;
  try {
    const res = await fetch(BRAND_URL, { cache: "no-cache" });
    if (!res.ok) throw new Error(String(res.status));
    const json = await res.json();
    cached = { ...DEFAULT_BRAND, ...json };
  } catch {
    cached = DEFAULT_BRAND;
  }
  return cached;
};

/** 套用瀏覽器分頁標題與 favicon（index.html 裡的值是編譯時寫死的，這裡覆寫） */
const applyDocumentBrand = (brand) => {
  if (brand.appName) document.title = brand.appName;
  if (brand.favicon) {
    let link = document.querySelector("link[rel~='icon']");
    if (!link) {
      link = document.createElement("link");
      link.rel = "icon";
      document.head.appendChild(link);
    }
    link.href = brand.favicon;
  }
};

export const useBrand = () => {
  const [brand, setBrand] = useState(cached || DEFAULT_BRAND);

  useEffect(() => {
    let cancelled = false;
    loadBrand().then((b) => {
      if (cancelled) return;
      setBrand(b);
      applyDocumentBrand(b);
    });
    return () => {
      cancelled = true;
    };
  }, []);

  return brand;
};
